
import { useRecoilValue } from "recoil" ;
import { runtimeEnvState } from "state/ecoState";

/**
 * Get Runtime env 
 */
const useRuntimeEnv = () => useRecoilValue(runtimeEnvState)  ;

export default useRuntimeEnv ;